var widget_default = {
  "card": "tWb6D",
  "link": "PoZGF",
  "container": "_5sVpF",
  "image": "MiDyt",
  "right": "lZjpe",
  "cardLayout": "e2bVz",
  "content": "NpN6q",
  "title": "i4btF",
  "subtitle": "_0Quyq",
  "button": "_0i-t7",
  "button_disabled": "X4ZC8",
  "buttonText": "mLml0",
  "slimLayout": "ygH7w",
  "contentText": "fpUEW"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
